import {
  SchedulePreviewAppointment,
  UpcomingAgendaCardConnected,
  UpcomingAgendaErrorCard,
  ProviderEventType,
  useSetCoachConversation,
  CoachConversation,
} from "@grow-therapy-team/seedling-components";
import { ErrorBoundary } from "react-error-boundary";
import { EventTypeEnum } from "../../segment/types";
import { useCallback } from "react";
import { useOpenClientInformationCallback } from "../client-information/useClientInformationDrawerCallbacks";
import { useTrackEvent } from "../../segment/segment";
import { useSetAtom } from "jotai";
import { scheduledPatientInformationAtom } from "../schedule-preview/state";
import { PreVisitSummaryCardNudgeWrapper } from "../client-information/pre-visit-summary/PreVisitSummaryCardNudgeWrapper";

export function UpcomingAgendaWrapper() {
  const setScheduledPatientInfo = useSetAtom(scheduledPatientInformationAtom);
  const { userClicked } = useTrackEvent();
  const openClientInformation = useOpenClientInformationCallback();
  const { setCoachConversation } = useSetCoachConversation();

  const openClientInfoDrawerForAppointment = useCallback(
    (appointment: SchedulePreviewAppointment["node"]) => {
      const patientShortId = appointment?.patient.shortId;
      const patientName = appointment?.patient.preferredFullName;
      setScheduledPatientInfo({
        name: patientName,
        patientShortId: patientShortId,
        appointmentType: appointment.appointmentType,
        appointmentStartTime: appointment.timeStart,
        appointmentEndTime: appointment.timeEnd,
        recurringAppointmentGrouping: appointment.recurringAppointmentGrouping,
        appointmentLocation: appointment.inOffice,
        appointmentId: appointment.id,
        appointmentShortId: appointment.appointmentShortId,
        patientId: appointment.patient.id,
        patientName: appointment.patient.preferredFullName,
        recurringAppointmentGroupingId:
          appointment?.recurringAppointmentGrouping
            ?.recurringAppointmentGroupingId,
        indefinite: appointment?.recurringAppointmentGrouping?.indefinite,
        start: appointment.time_start,
        end: appointment.time_end,
        virtual: appointment.virtual === "virtual",
        weeksBetween: appointment?.recurringAppointmentGrouping?.weeksBetween,
        numRecurrences:
          appointment?.recurringAppointmentGrouping?.appointments?.length,
        recurrenceRule:
          appointment?.recurringAppointmentGrouping?.recurrenceRule,
        version: appointment?.recurringAppointmentGrouping?.version,
      });
      openClientInformation(patientShortId);
    },
    [setScheduledPatientInfo, openClientInformation],
  );
  const onClickAppointmentTile = useCallback(
    (
      appointmentNode: SchedulePreviewAppointment,
      appointmentPosition: number,
    ) => {
      const appointment = appointmentNode.node;
      openClientInfoDrawerForAppointment(appointment);
      userClicked(EventTypeEnum.WAITING_ROOM_SCHEDULE, {
        appointmentPosition,
        appointmentShortId: appointment?.appointmentShortId,
      });
    },
    [openClientInfoDrawerForAppointment, userClicked],
  );

  // @ts-expect-error - TODO: CARED-2707
  const _onClickAISummarization = useCallback(
    (appointment: SchedulePreviewAppointment["node"]) => {
      openClientInfoDrawerForAppointment(appointment);
    },
    [openClientInfoDrawerForAppointment],
  );

  // @ts-expect-error - TODO: CARED-2707
  const _onClickResources = useCallback(
    (appointment: SchedulePreviewAppointment["node"]) => {
      openClientInfoDrawerForAppointment(appointment);
    },
    [openClientInfoDrawerForAppointment],
  );

  // @ts-expect-error - TODO: CARED-2707
  const _onClickTopicsSharedByClient = useCallback(
    (appointment: SchedulePreviewAppointment["node"]) => {
      openClientInfoDrawerForAppointment(appointment);
    },
    [openClientInfoDrawerForAppointment],
  );

  const onClickUnreadCoachConversation = useCallback(
    (
      appointment: SchedulePreviewAppointment["node"],
      conversation: CoachConversation,
    ) => {
      openClientInfoDrawerForAppointment(appointment);
      setCoachConversation(conversation);
    },
    [openClientInfoDrawerForAppointment, setCoachConversation],
  );

  return (
    <ErrorBoundary
      FallbackComponent={() => (
        <UpcomingAgendaErrorCard cardClassName="max-h-[80%] sm:w-[40rem] w-full flex flex-col overflow-auto" />
      )}
    >
      <UpcomingAgendaCardConnected
        onClickAppointmentTile={onClickAppointmentTile}
        preVisitSummaryProviderViewEventType={
          ProviderEventType.VIEWED_PRE_VISIT_SUMMARY_NO_MEDICAL_RECORD_UPCOMING_APPOINTMENT_TELEHEALTH
        }
        cardClassName="max-h-[80%] sm:w-[40rem] w-full flex flex-col overflow-auto"
        preVisitSummaryNudgeContext="telehealth-waiting-room"
        preVisitSummaryCardComponent={PreVisitSummaryCardNudgeWrapper}
        preVisitSummaryOnClickUnreadCoachConversation={
          onClickUnreadCoachConversation
        }
      />
    </ErrorBoundary>
  );
}
